/**
 * A radio group answers the arrow keys, as the ARIA pattern promises: one tab
 * stop for the group, arrows (and Home, End) move and choose. Put it on the
 * element with role="radiogroup" as a keydown handler.
 */
export function radioKeys(event) {
  const keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
  const radios = [...event.currentTarget.querySelectorAll('[role="radio"]')];
  const at = radios.indexOf(document.activeElement);
  if (at < 0) return;
  let to = null;
  if (event.key in keys) to = (at + keys[event.key] + radios.length) % radios.length;
  else if (event.key === 'Home') to = 0;
  else if (event.key === 'End') to = radios.length - 1;
  if (to === null) return;
  event.preventDefault();
  radios[to].click();
  radios[to].focus();
}
